export const UPDATE_INTERVAL = 1800000;
export const CONFIG_URL = `${window.location.origin}/config.json`;
export const IMAGES_URL = `${window.location.origin}/media/`;
